import Vue from 'vue'
import '@progress/kendo-ui'
import '../assets/kendo-finstar.css'
import '@progress/kendo-ui/js/kendo.aspnetmvc'

import {GridInstaller} from '@progress/kendo-grid-vue-wrapper'
import {ValidatorInstaller} from '@progress/kendo-validator-vue-wrapper'
import {DateinputsInstaller} from '@progress/kendo-dateinputs-vue-wrapper'
import {DropdownsInstaller} from '@progress/kendo-dropdowns-vue-wrapper'
import {ButtonsInstaller} from '@progress/kendo-buttons-vue-wrapper'
import {WindowInstaller} from '@progress/kendo-window-vue-wrapper'
import {InputsInstaller} from '@progress/kendo-inputs-vue-wrapper'
import {SpreadsheetInstaller} from '@progress/kendo-spreadsheet-vue-wrapper'
import {ListBoxInstaller} from '@progress/kendo-listbox-vue-wrapper'

import {DataSourceInstaller} from '@progress/kendo-datasource-vue-wrapper'

Vue.use(DateinputsInstaller)
Vue.use(GridInstaller)
Vue.use(ValidatorInstaller)
Vue.use(DropdownsInstaller)
Vue.use(ButtonsInstaller)
Vue.use(WindowInstaller)
Vue.use(InputsInstaller)
Vue.use(DataSourceInstaller)
Vue.use(SpreadsheetInstaller)
Vue.use(ListBoxInstaller)
